import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { getPayload, loadingStatus } from "actions"
import Title from "../general/title"
import _ from "lodash"
import * as Yup from "yup"
import { Formik, Field, Form, FieldArray } from "formik"
import fieldStatus from "helpers/fieldStatus"
import superagent from "superagent"
import { toast } from "react-toastify"
import settings from "settings"
import arcFields from "models/arc"
import ReactSelect from "components/ReactSelect"
import NumberField from "components/NumberField"
import elevationFields from "models/elevation"
import TextArea from "components/TextArea"
import currentUser from "helpers/currentUser"
import nullToEmptyString from "helpers/nullToEmptyString"
import matchModel from "helpers/matchModel"
import classnames from "classnames"
import request from "superagent"
import Dropzone from "react-dropzone"
import ARCMasterHistory from "containers/modals/arcMasterHistory"
import moment from "moment"

class ARCSubmitMaster extends Component {
	constructor(props) {
		super(props)
		// load the first elevation row
		let c = _.clone(elevationFields)
		this.state = {
			fields: arcFields,
			currentFile: "",
			reviewerFile: "",
			currentIndex: -1, // index of arc_approved for this property
			currentApproved: null,
			clone: _.cloneDeep(elevationFields),
			fullFloorplan: {},
			showHistory: false,
			user: currentUser(),
		}
	}

	buildData = () => {
		let id
		if (this.props?.match?.params?.id) {
			// normal interface through entry portal
			id = parseInt(this.props.match.params.id)
		} else {
			// try to get off props on admin edit side
			id = this.props.fullPlan?.id
		}
		let fields = _.find(this.props.payload.public.floorplans, { id: id })
		let fullFloorplan = _.cloneDeep(fields)
		fields = nullToEmptyString(fields)
		let types = []
		_.forEach(fields.lot_types, (v) => {
			if (v.property === this.props.activeProperties[0]) {
				types.push(v.lot_type)
			}
		})
		let comments = ""
		_.forEach(fields.arc_builder_comments, (v) => {
			if (v.property === this.props.activeProperties[0]) {
				comments = v.comments
			}
		})
		fields.arc_builder_comments = comments
		fields.lot_types = types
		fields.property = this.props.activeProperties[0]
		let elevations = []
		_.forEach(this.props.payload.public.elevations, (v) => {
			if (v.floorplan == id && v.property === this.props.activeProperties[0]) {
				elevations.push({
					id: v.id,
					name: v.name,
					min_sqft: v.min_sqft,
					max_sqft: v.max_sqft,
					style: v.style,
					notes: v.notes,
					image: v.image,
				})
			}
		})
		let currentFile = ""
		let fileFind = _.find(fields.arc_file, { property: this.props.activeProperties[0] })
		if (fileFind) {
			currentFile = fileFind.file
		}
		fields.elevations = elevations
		fields.arc_file = ""
		let currentIndex = -1
		let currentApproved = null
		let approved = _.findIndex(fields.arc_approved, { property: fields.property })
		if (approved !== -1) {
			currentIndex = approved
			currentApproved = fields.arc_approved[approved]
		}
		let reviewerFile
		if (Array.isArray(fields?.arc_reviewer_files)) {
			let f = _.find(fields.arc_reviewer_files, {
				property: String(this.props.activeProperties[0]),
				type: "approval",
			})
			if (f) reviewerFile = f.file
		}
		fields = matchModel(arcFields, fields)

		this.setState({ fields, currentFile, reviewerFile, currentIndex, currentApproved, fullFloorplan }, () => {
			//console.log(this.state)
		})
	}

	componentDidMount() {
		this.buildData()
	}

	componentDidUpdate(prevProps, prevState) {
		if (!_.isEqual(prevProps, this.props)) {
			this.buildData()
		}
	}

	validation = () => {
		return Yup.object().shape({
			name: Yup.string().required("Required"),
			plan_number: Yup.string().required("Required"),
			builder: Yup.number().required("Required"),
			property: Yup.number().required("Required"),
			stories: Yup.number().required("Required"),
			beds: Yup.number().required("Required"),
			garage: Yup.number().required("Required"),
			sqft: Yup.number().required("Required"),
			full_baths: Yup.number().required("Required"),
			half_baths: Yup.number().required("Required"),
			lot_types: Yup.array().min(1, "Please choose at least one lot type.").required(),
			base_width_feet: Yup.number().required("Required"),
			base_width_inches: Yup.number().required("Required"),
		})
	}

	options = (f, name) => {
		let ret = []
		this.props.payload.public[name].forEach((v) => {
			if (f.values.property && f.values.property == v.property) {
				ret.push({ label: v.name, value: v.id })
			}
		})

		ret = _.sortBy(ret, "label")
		return ret
	}

	buildClassifications = () => {
		let ret = []
		_.forEach(this.props.payload.public.floorplan_classifications, (v) => {
			ret.push({ label: v.name, value: v.id })
		})
		return ret
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	buildProperties = () => {
		let ret = []
		_.forEach(this.props.payload.public.properties, (v) => {
			if (this.state.user.activeProperties.includes(v.id)) {
				ret.push({ label: v.name, value: v.id })
			}
		})
		return ret
	}

	buildBuilders = () => {
		let ret = []
		if (this.props.admin) {
			// Admin editing so should see all the builders in this community
			_.forEach(this.props.payload.public.builders, (v) => {
				if (v.properties.includes(this.props.fullPlan?.property)) {
					ret.push({ label: v.name, value: v.id })
				}
			})
			return ret
		} else if (!this.state.user.builders) return []
		_.forEach(this.props.payload.public.builders, (v) => {
			if (this.state.user.builders.includes(v.id)) {
				ret.push({ label: v.name, value: v.id })
			}
		})
		return ret
	}

	getElevation = (id) => {
		try {
			let lookup = _.find(this.props.payload.public.elevations, { id })
			if (lookup) {
				return lookup
			}
		} catch (e) {
			console.log(e)
		}
		return null
	}

	renderElevationFields = (f, index, arrayHelpers) => {
		let approvalStatus = ""
		try {
			let lookup = this.getElevation(f.values.elevations[index].id)
			if (lookup) {
				let status = lookup.approval_status
				if (status === 1) approvalStatus = "Approved"
				else if (status === 0) approvalStatus = "Rejected"
				else if (status === null) approvalStatus = "Under Review"
			}
		} catch (e) {
			console.log(e)
		}
		let classifications
		if (this.props.payload.public.floorplan_classifications?.length) {
			classifications = (
				<li className={fieldStatus("style", f)}>
					<label htmlFor="style">Style</label>
					{f.errors.length > 0 && f.errors.elevations[index].style && f.touched.elevations[index].style && (
						<div className="form__message">{f.errors.elevations[index].style}</div>
					)}
					<ReactSelect
						name={`elevations.${index}.style`}
						options={this.buildClassifications()}
						value={f.values.elevations[index].style}
						onBlur={f.setFieldTouched}
						onChange={f.setFieldValue}
						clearable
					/>
				</li>
			)
			if (settings.disabled?.builderAssignFloorplanClassifications && approvalStatus === "Approved") {
				let style = _.find(this.props.payload.public.floorplan_classifications, {
					id: f.values.elevations[index].style,
				})
				classifications = (
					<li className={fieldStatus("style", f)}>
						<label htmlFor="style">Style</label>
						{style ? style.name : "Unknown"}
					</li>
				)
			}
		}
		return (
			<React.Fragment>
				<li className={fieldStatus("name", f, true, index, null, { static: true })}>
					<p
						className={classnames(
							"absolute top-0 left-0 px-3 py-2 text-xs font-bold text-white rounded-br-md",
							{
								"bg-green-700": approvalStatus === "Approved",
								"bg-red-500": approvalStatus === "Rejected",
								"bg-yellow-500": approvalStatus === "Under Review",
							}
						)}>
						{approvalStatus}
					</p>
					<label htmlFor="name">
						Name <sup>*</sup>
					</label>
					{f.errors.length > 0 && f.errors.elevations[index].name && f.touched.elevations[index].name && (
						<div className="form__message">{f.errors.elevations[index].name}</div>
					)}
					<Field
						onBlur={() => f.setFieldTouched(`elevations[${index}].name`, true)}
						name={`elevations.${index}.name`}
						type="text"
						className="form__input"
					/>
				</li>
				<li className={fieldStatus("min_sqft", f, true, index)}>
					<label htmlFor="min_sqft">
						Min Square Feet <sup>*</sup>
					</label>
					{f.errors.length > 0 &&
						f.errors.elevations[index].min_sqft &&
						f.touched.elevations[index].min_sqft && (
							<div className="form__message">{f.errors.elevations[index].min_sqft}</div>
						)}
					<NumberField
						name={`elevations.${index}.min_sqft`}
						type="text"
						className="form__input"
						onChange={(v, r) => f.setFieldValue(`elevations[${index}].min_sqft`, parseInt(r))}
						onBlur={() => f.setFieldTouched(`elevations[${index}].min_sqft`, true)}
						touched={() => f.setFieldTouched(`elevations[${index}].min_sqft`, true)}
						//error={f.errors.elevations[index].min_sqft}
						value={f.values.elevations[index].min_sqft}
						thousandSeparator={true}
					/>
				</li>
				<li className={fieldStatus("max_sqft", f, true, index)}>
					<label htmlFor="max_sqft">
						Max Square Feet <sup>*</sup>
					</label>
					{f.errors.length > 0 &&
						f.errors.elevations[index].max_sqft &&
						f.touched.elevations[index].max_sqft && (
							<div className="form__message">{f.errors.elevations[index].max_sqft}</div>
						)}
					<NumberField
						name={`elevations.${index}.max_sqft`}
						type="text"
						className="form__input"
						onChange={(v, r) => f.setFieldValue(`elevations[${index}].max_sqft`, parseInt(r))}
						onBlur={() => f.setFieldTouched(`elevations[${index}].max_sqft`, true)}
						touched={() => f.setFieldTouched(`elevations[${index}].max_sqft`, true)}
						//error={f.errors.elevations[index].max_sqft}
						//value={f.values.base_width_feet}
						value={f.values.elevations[index].max_sqft}
						thousandSeparator={true}
					/>
				</li>
				{classifications}
				<li className="pt-3">
					<label>Image</label>
					{f.values.elevations[index].image ? (
						<div className="relative">
							<i
								className="fas fa-times-circle formFiles__removeIcon"
								onClick={() => {
									f.setFieldValue(`elevations.${index}.image`, "")
								}}></i>
							<img
								src={`${settings.s3}/${f.values.elevations[index].image}`}
								alt="elevation"
								className="elevation__image"
								style={{ maxWidth: "200px", maxHeight: "200px" }}
							/>
						</div>
					) : (
						<Dropzone
							multiple={false}
							onDrop={(files) => {
								const req = request.post(`${settings.ep}/inputBuilderElevationImage`)
								for (let v of files) {
									req.attach(v.name, v)
								}
								//req.attach(files[0].name, files[0])
								req.set("Authorization", `Bearer ${localStorage.user}`)
								req.end((err, response) => {
									//return
									let resp = response.body
									//return
									if (err) {
										console.log(err)
									}
									if (resp.status == 200) {
										f.setFieldValue(`elevations.${index}.image`, resp.data)
									}
								})
							}}>
							{({ getRootProps, getInputProps }) => (
								<section className="dropzone">
									<div {...getRootProps()} className="dropbox__cont">
										<input {...getInputProps()} />
										<p className="dropzone__action">
											Drag 'n' drop file here, or click to select files
										</p>
									</div>
								</section>
							)}
						</Dropzone>
					)}
				</li>
				<li className={fieldStatus("notes", f, true, index, true)}>
					<label htmlFor="notes">Notes</label>
					{f.errors.length > 0 && f.errors.elevations[index].notes && f.touched.elevations[index].notes && (
						<div className="form__message">{f.errors.elevations[index].notes}</div>
					)}
					<Field
						onBlur={() => f.setFieldTouched(`elevations[${index}].notes`, true)}
						name={`elevations.${index}.notes`}
						component="textarea"
						className="form__input"
					/>
				</li>
				<li className="form__subItemRemove">
					<i className="fa fa-minus-circle" onClick={() => arrayHelpers.remove(index)} />
				</li>
			</React.Fragment>
		)
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else {
			let rejection
			if (
				this.state.currentApproved &&
				!this.state.currentApproved.approved &&
				this.state.currentApproved.rejected &&
				this.state.currentApproved.rejection_reason
			) {
				rejection = (
					<div style={{ marginBottom: 30 }} className="callout">
						<h3 style={{ color: "white" }}>Rejection Reason</h3>
						<p>{this.state.currentApproved.rejection_reason}</p>
					</div>
				)
			}
			let approvedNotes = _.get(this.state.currentApproved, `approval_comments`)
			let approvalStatus = _.get(this.state.currentApproved, `approved`)
			return (
				<div className="entryDashboard">
					<div className="imageGroup">
						<Title title="Edit ARC Master Submission" showDate={false} hideExport={this.props.hideExport} />
						{settings.arc && (
							<div className="content">
								<div className="flex justify-end">
									<div
										className="flex items-center"
										onClick={() => {
											this.setState({ showHistory: true })
										}}>
										<a className="bg-blue px-2 py-1 rounded-lg text-xs text-white cursor-pointer">
											View History
										</a>
									</div>
								</div>
							</div>
						)}
						<div className="content">
							{this.state.user.group == 14 && (
								<>
									<p className="mid alertNote">
										<i className={`fas fa-info-circle`} style={{ marginRight: 5 }} />
										Please note that edits to approved master plans will return the master plan back
										to an under review state.
									</p>
									{approvedNotes && approvalStatus && (
										<p className="successNote">Master Plan Approval Notes: {approvedNotes}</p>
									)}
								</>
							)}
							<Formik
								enableReinitialize
								initialValues={this.state.fields}
								validationSchema={this.validation}
								validateOnMount={true}
								onSubmit={(values) => {
									this.props.loadingStatus(true)
									if (this.props?.match?.params?.id) values.id = parseInt(this.props.match.params.id)
									else if (this.props.fullPlan?.id) values.id = this.props.fullPlan?.id
									if (!values.id) {
										console.log("No ID")
										return
									}
									if (this.props.admin) values.adminEdit = true
									let json = JSON.stringify(values)
									//this.props.loadingStatus(true)
									var fd = new FormData()
									for (let k in values) {
										fd.append(k, values[k])
									}
									var user = localStorage.getItem("user")
									superagent
										.post(settings.ep + "/editARCPlan")
										.attach("arc_file", values.arc_file)
										.field("data", json)
										.set("Authorization", user)
										.end((err, resp) => {
											if (err) {
												console.log(err)
												toast.error("Error submitting.  Please notify developers.")
												return
											}
											this.props.loadingStatus(false)
											toast.success(resp.body.message)
											if (this.props?.admin) {
												this.props.onClose()
											} else {
												this.setState(
													{
														redirect: true,
														redirectPath: resp.body.redirect,
													},
													() => {
														this.props.getPayload()
													}
												)
											}
										})
								}}>
								{(f) => (
									<div>
										<Form>
											{/* console.log(f) */}
											<ul className="form__list">
												<li className={fieldStatus("name", f)}>
													<label htmlFor="name">
														Plan Name <sup>*</sup>
													</label>
													{f.errors.name && f.touched.name && (
														<div className="form__message">{f.errors.name}</div>
													)}
													<Field name="name" type="text" className="form__input" />
												</li>
												<li className={fieldStatus("plan_number", f)}>
													<label htmlFor="plan_number">
														Plan Number <sup>*</sup>
													</label>
													{f.errors.plan_number && f.touched.plan_number && (
														<div className="form__message">{f.errors.plan_number}</div>
													)}
													<Field name="plan_number" type="text" className="form__input" />
												</li>
												<li className={fieldStatus("builder", f)}>
													<label htmlFor="builder">
														Builder <sup>*</sup>
													</label>
													{f.errors.builder && f.touched.builder && (
														<div className="form__message">{f.errors.builder}</div>
													)}
													<ReactSelect
														name={`builder`}
														options={this.buildBuilders()}
														value={f.values.builder}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("property", f)}>
													<label htmlFor="property">
														Property <sup>*</sup>
													</label>
													{f.errors.property && f.touched.property && (
														<div className="form__message">{f.errors.property}</div>
													)}
													<ReactSelect
														name={`property`}
														options={this.buildProperties()}
														value={f.values.property}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("stories", f)}>
													<label htmlFor="stories">Stories</label>
													{f.errors.stories && f.touched.stories && (
														<div className="form__message">{f.errors.stories}</div>
													)}
													<ReactSelect
														name={`stories`}
														options={[
															{ label: 1, value: 1 },
															{ label: 1.5, value: 1.5 },
															{ label: 2, value: 2 },
															{ label: 2.5, value: 2.5 },
															{ label: 3, value: 3 },
															{ label: 3.5, value: 3.5 },
															{ label: 4, value: 4 },
														]}
														//isMulti
														value={f.values.stories}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("lot_types", f)}>
													<label htmlFor="lot_types">Lot Types</label>
													{f.errors.lot_types && f.touched.lot_types && (
														<div className="form__message">{f.errors.lot_types}</div>
													)}
													<ReactSelect
														name={`lot_types`}
														options={this.options(f, "lot_types")}
														isMulti
														value={f.values.lot_types}
														onBlur={f.setFieldTouched}
														onChange={f.setFieldValue}
													/>
												</li>
												<li className={fieldStatus("base_width_feet", f)}>
													<label htmlFor="base_width_feet">Base Width Feet</label>
													{f.errors.base_width_feet && f.touched.base_width_feet && (
														<div className="form__message">{f.errors.base_width_feet}</div>
													)}
													<NumberField
														name="base_width_feet"
														type="text"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.base_width_feet}
														error={f.errors.base_width_feet}
														value={f.values.base_width_feet}
														thousandSeparator={true}
													/>
												</li>
												<li className={fieldStatus("base_width_inches", f)}>
													<label htmlFor="base_width_inches">Base Width Inches</label>
													{f.errors.base_width_inches && f.touched.base_width_inches && (
														<div className="form__message">
															{f.errors.base_width_inches}
														</div>
													)}
													<NumberField
														name="base_width_inches"
														type="text"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.base_width_inches}
														error={f.errors.base_width_inches}
														value={f.values.base_width_inches}
														thousandSeparator={true}
													/>
												</li>
												<li className={fieldStatus("sqft", f)}>
													<label htmlFor="sqft">Square Footage</label>
													{f.errors.sqft && f.touched.sqft && (
														<div className="form__message">{f.errors.sqft}</div>
													)}
													<NumberField
														name="sqft"
														type="text"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.sqft}
														error={f.errors.sqft}
														value={f.values.sqft}
														thousandSeparator={true}
													/>
												</li>
												<li className={fieldStatus("garage", f)}>
													<label htmlFor="garage">Garage</label>
													{f.errors.garage && f.touched.garage && (
														<div className="form__message">{f.errors.garage}</div>
													)}
													<NumberField
														name="garage"
														type="text"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.garage}
														error={f.errors.garage}
														value={f.values.garage}
														thousandSeparator={true}
													/>
												</li>
												<li className={fieldStatus("full_baths", f)}>
													<label htmlFor="full_baths">Full Baths</label>
													{f.errors.full_baths && f.touched.full_baths && (
														<div className="form__message">{f.errors.full_baths}</div>
													)}
													<NumberField
														name="full_baths"
														type="text"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.full_baths}
														error={f.errors.full_baths}
														value={f.values.full_baths}
														thousandSeparator={true}
													/>
												</li>
												<li className={fieldStatus("half_baths", f)}>
													<label htmlFor="half_baths">Half Baths</label>
													{f.errors.half_baths && f.touched.half_baths && (
														<div className="form__message">{f.errors.half_baths}</div>
													)}
													<NumberField
														name="half_baths"
														type="text"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.half_baths}
														error={f.errors.half_baths}
														value={f.values.half_baths}
														thousandSeparator={true}
													/>
												</li>
												<li className={fieldStatus("beds", f)}>
													<label htmlFor="beds">Beds</label>
													{f.errors.beds && f.touched.beds && (
														<div className="form__message">{f.errors.beds}</div>
													)}
													<NumberField
														name="beds"
														type="text"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.beds}
														error={f.errors.beds}
														value={f.values.beds}
														thousandSeparator={true}
													/>
												</li>
												<li className={fieldStatus("masonry_percent", f)}>
													<label htmlFor="masonry_percent">Masonry %</label>
													{f.errors.masonry_percent && f.touched.masonry_percent && (
														<div className="form__message">{f.errors.masonry_percent}</div>
													)}
													<NumberField
														name="masonry_percent"
														type="text"
														className="form__input"
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.masonry_percent}
														error={f.errors.masonry_percent}
														value={f.values.masonry_percent}
														thousandSeparator={true}
													/>
												</li>
												<li className={fieldStatus("roof_pitch", f)}>
													<label htmlFor="roof_pitch">Roof Pitch</label>
													{f.errors.roof_pitch && f.touched.roof_pitch && (
														<div className="form__message">{f.errors.roof_pitch}</div>
													)}
													<Field name="roof_pitch" type="text" className="form__input" />
												</li>
												<li className={fieldStatus("height", f)}>
													<label htmlFor="height">Total Height</label>
													{f.errors.height && f.touched.height && (
														<div className="form__message">{f.errors.height}</div>
													)}
													<Field name="height" type="text" className="form__input" />
												</li>
												{this.props.payload.public.floorplan_classifications?.length &&
												!settings?.disabled?.builderAssignFloorplanClassifications ? (
													<li className={fieldStatus("classifications", f)}>
														<label htmlFor="classifications">Classifications</label>
														{f.errors.classifications && f.touched.classifications && (
															<div className="form__message">
																{f.errors.classifications}
															</div>
														)}
														<ReactSelect
															name={`classifications`}
															options={this.buildClassifications()}
															isMulti
															value={f.values.classifications}
															onBlur={f.setFieldTouched}
															onChange={f.setFieldValue}
															clearable
														/>
													</li>
												) : null}
												<li className={fieldStatus("arc_file", f)}>
													<label htmlFor="arc_file">Edit Plan File</label>
													<p className="small">
														Must be one file with elevations and all plan details included.
													</p>
													{f.errors.arc_file && f.touched.arc_file && (
														<div className="form__message">{f.errors.arc_file}</div>
													)}
													<div className="flex mt-1">
														{this.state.currentFile && (
															<a
																href={`${settings.s3}${
																	this.state.currentFile
																}?v=${moment().unix()}`}
																target="_blank"
																className="text-xs btn"
																style={{ marginBottom: 20 }}>
																View Current File
															</a>
														)}
														{this.state.reviewerFile && (
															<a
																href={`${settings.s3}/${
																	this.state.reviewerFile
																}?v=${moment().unix()}`}
																target="_blank"
																className="btn text-xs ml-2"
																style={{ marginBottom: 20 }}>
																View Reviewer File
															</a>
														)}
													</div>
													<input
														name="arc_file"
														type="file"
														id="arc_file"
														className="noBorder"
														onChange={(event) => {
															f.setFieldValue("arc_file", event.currentTarget.files[0])
														}}
													/>
												</li>
												<li
													className={fieldStatus(
														"arc_builder_comments",
														f,
														null,
														null,
														true
													)}>
													<label htmlFor="arc_builder_comments">Comments</label>
													{f.errors.arc_builder_comments &&
														f.touched.arc_builder_comments && (
															<div className="form__message">
																{f.errors.arc_builder_comments}
															</div>
														)}
													<TextArea
														name="arc_builder_comments"
														className="form__textarea"
														value={f.values.arc_builder_comments}
														onChange={f.setFieldValue}
														onBlur={f.setFieldTouched}
														touched={f.touched.arc_builder_comments}
														error={f.errors.arc_builder_comments}
													/>
												</li>
											</ul>
											{rejection}
											<h3>Elevations</h3>
											<FieldArray
												name="elevations"
												render={(arrayHelpers) => (
													<div>
														<p className="traffic__addMore">
															<span
																onClick={() => {
																	//console.log(trafficFields)
																	return arrayHelpers.insert(0, this.state.clone)
																}}>
																<i className="fa fa-plus-circle" />
																Add Another Elevation
															</span>
														</p>
														<ul>
															{f.values.elevations && f.values.elevations.length > 0
																? f.values.elevations.map((row, index) => (
																		<li key={index}>
																			<ul className="form__subList relative">
																				{this.renderElevationFields(
																					f,
																					index,
																					arrayHelpers
																				)}
																			</ul>
																		</li>
																  ))
																: ""}
														</ul>
													</div>
												)}
											/>
											<input
												type="submit"
												value="Submit"
												className={this.submitClasses(f.isValid)}
											/>
										</Form>
									</div>
								)}
							</Formik>
							<ARCMasterHistory
								showHistory={this.state.showHistory}
								data={this.state.fullFloorplan}
								onClose={() => {
									this.setState({ showHistory: false })
								}}
							/>
						</div>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		currentDates: state.currentDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(ARCSubmitMaster)
